import { IconButtonProps, SecondaryIconButton } from '@project-minerva/design-system'

export const CloseButton = (props: IconButtonProps) => (
  <SecondaryIconButton aria-label="close" sx={{ ml: 'auto' }} {...props}>
    <img alt="Back Button" src="assets/images/admin/icon-close-12.svg" />
  </SecondaryIconButton>
)
